var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:[_vm.color, _vm.color !='' ? 'white--text': '']},[_vm._v(_vm._s(_vm.valor ? 'SI' : 'NO'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }